import regions from "../../common/regions";

const actions = {
  SET_REGIONS: "SET_REGIONS",
  setRegions: (payload) => ({
    type: actions.SET_REGIONS,
    payload,
  }),
};

export const initialState = {
  regions,
  cities: [],
  directions: [],
  districts: [],
};

export default function regionsReducer(state, action) {
  switch (action.type) {
    case actions.SET_REGIONS:
      return {
        ...state,
        regions: action.payload,
      };
    default:
      throw new Error("Unsupported action type at listingsList reducer");
  }
}
